import { getItemBounds } from 'app/core/markers/bounds';
import { getMarkerStyles } from 'app/core/markers/models';
import { applyCrop } from 'app/utils/geom';
import { strokeMarkerRenderer } from './painters';
export const renderImageMarker = (marker, opts, ctx, images) => {
    const item = marker;
    const bounds = getItemBounds(marker);
    const painter = (pCtx) => {
        pCtx.beginPath();
        // to get correct rect
        pCtx.rect(item.x, item.y, bounds.width, bounds.height);
        pCtx.closePath();
    };
    ctx.save();
    strokeMarkerRenderer(ctx, Object.assign(Object.assign({}, getMarkerStyles(marker)), { strokeJoin: 'miter', strokeCap: 'square' }), painter, opts);
    ctx.restore();
    const imageMarker = marker;
    const image = images[imageMarker.image];
    if (image) {
        let imageRect = image
            ? {
                x: 0,
                y: 0,
                width: image.width,
                height: image.height,
            }
            : undefined;
        if (item.crop) {
            imageRect = applyCrop(imageRect, item.crop);
        }
        ctx.save();
        ctx.drawImage(image, imageRect.x, imageRect.y, imageRect.width, imageRect.height, item.x, item.y, bounds.width, bounds.height);
        ctx.restore();
    }
};
